import { ComponentChild, h } from 'preact'
import ButtonControl from '../button-control'
import { common } from '../common'
import TitleInput from '../title-input/TitleInput'
import Tooltip from '../ui-components/Tooltip'
import { CustomButton } from '../header'
import OverviewSwitcher from '../ui-components/OverviewSwitcher'
import BetaBadge from '../ui-components/BetaBadge';

interface Props {
  type: string,
  isCustomView: boolean,
  title: string,
  isBeta?: boolean
  onSaveViewClicked: () => void,
  onShareView: () => void,
  onDeleteView: () => void,
  onTitleChanged: (title: string) => void,
  customButtons?: Array<CustomButton | ComponentChild>
}

const Header = (
  {
    type,
    isCustomView,
    title,
    onSaveViewClicked,
    onShareView,
    onDeleteView,
    onTitleChanged,
    customButtons,
    isBeta = false,
  }: Props) => {
  const isModeration = type === 'moderation'
  return (
    <div>
      <div class='control-header'>
        {isCustomView
          ? <TitleInput title={title} onTitleChanged={onTitleChanged} />
          : <h2 class='control-header__title'>{title}{common.isModuleActive('moderationOverviewBetaDefault') && <OverviewSwitcher />}{isBeta && <BetaBadge />}</h2>
        }
        { isModeration && <div className='control-header__action-buttons'>
          { isCustomView &&
            <ButtonControl
              onClick={onDeleteView}
              title='Delete'
              variant='warning'
              class='qa-delete-view'
              newStyle
              size='medium'
            />
          }
          <Tooltip
            trigger={<ButtonControl
              onClick={onShareView}
              title='Share view'
              class='qa-share-view'
              newStyle
              size='medium'
            />}
            tooltipMessage={'Share current filter and column settings with your team mates via URL'}
            qaClasses='qa-save-view-tooltip'
            withArrow
            position='center'
          />
          <ButtonControl
            onClick={onSaveViewClicked}
            title='Save view'
            variant='success'
            class='save-view'
            newStyle
            size='medium'
          />
        </div>}
        { customButtons && <div className='control-header__action-buttons'>{customButtons}</div> }
      </div>
    </div>
  )
}

export default Header
